import APMapHerePoint from './a-p-map-here-point';

export default APMapHerePoint;